let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8dp6A")).then(() => parcelRequire('jDcuT'));